import './listFlavor.scss'
import {DeleteRounded as DeleteIcon} from '@mui/icons-material'

const ListFlavor = ({listFlavor, onClick}) => {
    const list = Object.values(listFlavor.reduce((acc, item) => {
        if (!acc[item.sku]) {
            acc[item.sku] = { ...item }
        } else {
            acc[item.sku].amount += item.amount
        }
        return acc
    }, {}))
    return <div className={'list-flavor'}>
        {list.map((lf, i) => <div key={i} className={'div-list-flavor'}>
            <DeleteIcon className={'icon'} onClick={() => onClick(lf)}/>
            <label className={'label'}>
                {`${lf.amount}x ${lf.option}`}
            </label>
        </div>)}
    </div>
}

export default ListFlavor
